import { render, staticRenderFns } from "./academic_schdual_refereesystem_group_promote.vue?vue&type=template&id=8b72386e&scoped=true&"
import script from "./academic_schdual_refereesystem_group_promote.vue?vue&type=script&lang=js&"
export * from "./academic_schdual_refereesystem_group_promote.vue?vue&type=script&lang=js&"
import style0 from "./academic_schdual_refereesystem_group_promote.vue?vue&type=style&index=0&id=8b72386e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b72386e",
  null
  
)

export default component.exports